import {createAction} from 'web-app/util/redux/famly-app-helpers';

import {type TemperatureUnit} from './types';

const domain = 'MODALS/REGISTER_TEMPERATURE';

export const {action: show} = createAction(`${domain}/SHOW`, (childId: string) => ({
    childId,
}));

export const {action: hide} = createAction(`${domain}/HIDE`, () => ({}));

export const {
    action: registerTemperature,
    success: registerTemperatureSuccess,
    failed: registerTemperatureFailure,
} = createAction(
    `${domain}/REGISTER_TEMPERATURE`,
    (childId: string, payload: {degrees: number; unit: TemperatureUnit; note?: string}, occurredOn: string) => ({
        childId,
        payload,
        occurredOn,
    }),
);
